export default __webpack_public_path__ + "static/media/paper-2.30e2c95c.pdf";